import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/PageNotFound.css'; // Optional: Link to a CSS file for styling.

const PageNotFound = () => {
    const navigate = useNavigate();

    return (
        <div className="page-not-found">
            <h1>404</h1>
            <h2>Page Not Found</h2>
            <p>Sorry, the page you are looking for does not exist.</p>
            <button className="back-home-button" onClick={() => navigate('/')}>
                Go to Home
            </button>
        </div>
    );
};

export default PageNotFound;
